import { getRecommendActivityList } from '../../api';
import { Tag, Typography } from 'antd';
import { delay, isNull } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { BidActivityInfo } from './recommend-bid';
import ArrowRightGrey from './img/arrow-right-grey.svg';
import { completePictureLink } from './utils';
// import { currentShopUrl } from 'CONSTANTS/AppConst';
import { CaretRightOutlined } from '@ant-design/icons';
const prefixCls = 'high-traffic-activity';
const currentShopUrl = '';
export const delayExecFunc = (func) => {
  delay(func, 200);
};

export const getShowStr = (num) => {
  return isNull(num) ? '-' : num;
};

export const renderNoApplyElement = (str = '暂无报名商品') => {
  return <span style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.65)' }}>{str}</span>;
};

export const useRecommendActivityList = (menuOrder) => {
  const [recommendActivityList, setRecommendActivityList] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getRecommendActivityList({ tab: 0, menuOrder })
      .then((res = {}) => {
        const { ret, msg, data } = res;
        if (ret !== '0') {
          throw new Error(msg || '推荐活动接口请求失败');
        }
        if (Array.isArray(data)) {
          setRecommendActivityList(data || []);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return {
    recommendActivityList,
    loading,
  };
};

const renderActivityTypeTag = (activityInfo) => {
  const { activityTab } = activityInfo || {};
  if (!activityTab) return null;
  return (
    <>
      {activityTab.split(';').map((item, i) => (
        <Tag key={i} color="blue" className={`${prefixCls}-item-tag`}>
          {item}
        </Tag>
      ))}
    </>
  );
};

export const renderApplyStatusTag = (activityInfo) => {
  const { applyEndTime, applyBeginTime } = activityInfo;
  const isApplyEnd = moment(applyEndTime).diff(moment()) < 0;
  const isNotBegin = moment(applyBeginTime).diff(moment()) > 0;
  let applyStatusStr = '报名中';
  if (isNotBegin) {
    applyStatusStr = '报名即将开始';
  }
  if (isApplyEnd) {
    applyStatusStr = '报名已结束';
  }
  return (
    <Tag color="blue" className={`${prefixCls}-item-tag ${isApplyEnd || isNotBegin ? 'is-end' : ''}`}>
      {applyStatusStr}
    </Tag>
  );
};

export const renderTagElement = (activityInfo) => {
  return (
    <>
      {renderActivityTypeTag(activityInfo)}
      {/* {renderApplyStatusTag(activityInfo)} */}
    </>
  );
};

export const renderActivityNameAndTag = (activityInfo) => {
  const { activityName } = activityInfo;
  return (
    <>
      <Typography.Text ellipsis={{ tooltip: true }}>{activityName}</Typography.Text>
      <div className={`${prefixCls}-item-tag-container`}> {renderTagElement(activityInfo)}</div>
    </>
  );
};

// 推荐活动介绍
export const renderActivityIntroduce = (menu, isJimMaiSpecial, bidActivityInfo = {}, openSeckillLinkVersion) => {
  const { intro, jumpUrl, order } = menu;
  let jumUrlElement = <span onClick={() => window.open(jumpUrl)}>更多活动</span>;
  // order = 2 是百亿补贴固定链接
  if (order === 2) {
    jumUrlElement = (
      <span
        onClick={() => {
          const { activityId, areaId } = bidActivityInfo;
          const newBidUrl = `${currentShopUrl}/industry/detail/${activityId}?areaId=${areaId}&activityId=${activityId}`;
          if (activityId && areaId) {
            // window.open(openSeckillLinkVersion === 'old' ? oldBidUrl : newBidUrl)
            window.open(newBidUrl);
          }
          return;
        }}
      >
        查看全部可竞价商品
      </span>
    );
  }
  return (
    <div className="recommend-activity-introduce">
      <div className="recommend-activity-introduce-left">
        <img
          src="https://img11.360buyimg.com/img/jfs/t1/193274/2/42664/3567/6551de86Fcc09ffcf/e51c3ecc7be12fef.png"
          alt=""
          style={{ height: 24, marginRight: 8 }}
        />
        <span>{intro}</span>
      </div>
      <div className="recommend-activity-introduce-right" style={{ color: isJimMaiSpecial && '#8c8c8c' }}>
        {jumUrlElement}{' '}
        {isJimMaiSpecial ? (
          <img src={ArrowRightGrey} className={`${prefixCls}-tab-extra-content-icon`} />
        ) : (
          <CaretRightOutlined className={`${prefixCls}-tab-extra-content-icon`} />
        )}
      </div>
    </div>
  );
};

export const renderOpenSeckillSkuInfo = (activityInfo) => {
  const { canApplySkuList, cannotApplySkuList } = activityInfo || {};
  const canApplySkuListLength = Array.isArray(canApplySkuList) && canApplySkuList.length;
  const cannotApplySkuListLength = Array.isArray(cannotApplySkuList) && cannotApplySkuList.length;
  // 可报名只显示前6个
  if (canApplySkuListLength >= 6) {
    return (
      <div className="can-apply-sku-list">
        {/* {canApplySkuList.slice(0, 7).map((item) => (
          <div key={item.skuId} className="can-apply-sku-item">
            <img className="sku-item-img" src={completePictureLink(item.skuImage)} alt="" />
          </div>
        ))} */}
      </div>
    );
  }
  // 不可报名只显示前5个
  if (!canApplySkuListLength && cannotApplySkuListLength >= 4) {
    return (
      <div className="can-not-apply-sku-list">
        <span style={{ fontSize: 12, paddingRight: 12, flexShrink: 0, color: 'rgba(0, 0, 0, 0.65)' }}>运营后可报</span>
        {/* TODO */}
        {/* {cannotApplySkuList.slice(0, 5).map((item) => (
          <div key={item.skuId} className="can-not-apply-sku-item">
            <img className="sku-item-img" src={completePictureLink(item.skuImage)} alt="" />
          </div>
        ))} */}
      </div>
    );
  }
  // if (!canApplySkuListLength && !cannotApplySkuListLength) {
  //   return renderNoApplyElement('暂无可报商品');
  // }
  return null;
};
